import { BaseKey, IResourceComponentsProps, useExport, useGetIdentity, useMany, useNavigation, useShow, useUpdate } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  CloneButton,
  ShowButton,
  Typography,
  Popconfirm,
  Button,
  Tag,
  Input,
  Divider,
  Form,
  useTable,
  Row,
  Col,
} from '@pankod/refine-antd'
import Permissions from 'permissions'
import { IPaperTemplate, ITestTrack, IPaper } from 'interfaces'
import { CreatePaperTemplate } from './create'
import { CombinePaperTemplatesModal } from './combine'
import { EditPaperTemplate } from './edit'
import { ClonePaperTemplate } from './clone'
import { useEffect, useState } from 'react'
import { MergeCellsOutlined } from '@ant-design/icons'
import { useUserContext } from 'context/user'
import paperMetaData from 'metadata/paper'
import paperTemplateMetaData from 'metadata/paperTemplate'
import { getCount } from 'gql/query'


const { PlusOutlined } = Icons
type Permission = {
  granted?: boolean
}
interface Count {
  completed: number
  inprogress: number
  totalPaperTemplate: number
}
export const PaperTemplatesList: React.FC<IResourceComponentsProps> = () => {
  const { edit, clone, show } = useNavigation()
  const metaData = {
    fields: [
      'id',
      'name',
      'product_id',
      'sections',
      'description',
      'is_completed',
      { product: ['name', 'id'] },
      'test_track_id',
      { test_tracks: ['name'] },
      'created_at',
      'active',
    ],
  }
  const { queryResult, setShowId } = useShow<IPaperTemplate>({
    resource: 'paper_templates',
    metaData,
    queryOptions: { staleTime: Infinity },
  })
  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  const [hasPagination, setHasPagination] = useState<any>(true)
  const [paperTemplateCounts, setPaperTemplateCounts] = useState<Count>({ completed: 0, inprogress: 0, totalPaperTemplate: 0 })
  const [combineOpen, setCombineOpen] = useState(false)
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('paper_templates'))
      setCreatePermission(Permissions.can(userRole).createAny('paper_templates'))
      setEditPermission(Permissions.can(userRole).updateAny('paper_templates'))
      setDeletePermission(Permissions.can(userRole).deleteAny('paper_templates'))
    }
  }, [userRole])
  const {
    tableProps,
    sorter,
    tableQueryResult,
    setFilters: setPaperTemplateFilters,
    searchFormProps,
  } = useTable<IPaperTemplate>({
    hasPagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter: [
      {
        field: 'active',
        operator: 'eq',
        value: true,
      },
    ],
    // initialPageSize: 10,
    metaData: paperTemplateMetaData,
    queryOptions: { staleTime: Infinity },
    onSearch(data: any) {
      return [{ field: 'name', operator: 'contains', value: `%${data?.name}%` }]
    },
  })
  // { test_track: ["name", "id"] }

  // const { tableQueryResult: paperQueryResult } = useTable<IPaper>({ resource: 'papers', metaData: paperMetaData })
  // const hideDeleteButton = (id: string | BaseKey) => {
  //   const paperArr = (paperQueryResult?.data?.data && paperQueryResult?.data?.data.filter(eachPaper => eachPaper.paper_template_id === id)) ?? []
  //   return paperArr.length > 0
  // }
  const hasLinkedRecords = (record: IPaperTemplate): boolean => {
    if (record.papers !== undefined && record.paper_requests !== undefined) {
      return record.papers.length > 0 || record.paper_requests.length > 0
    }
    return false
  }

  // Templates allowed to stay editable even after papers or paper requests reference them.
  // Accepts an id or a name; remove an entry to restore the normal guard for that template.
  const EDIT_GUARD_EXCEPTIONS = ['TNA-Mock-UPM']

  const isEditGuardException = (record: IPaperTemplate): boolean =>
    EDIT_GUARD_EXCEPTIONS.includes(record.name) || EDIT_GUARD_EXCEPTIONS.includes(String(record.id))

  const {
    formProps,
    modalProps,
    show: createShow,
    close: createClose,
  } = useModalForm({
    resource: 'paper_templates',
    action: 'create',
    onMutationSuccess: async () => {
      await findPaperTemplateCounts()
    },
    redirect: 'list',
    metaData: paperTemplateMetaData,
  })
  modalProps.width = '100%'
  // const {
  //   formProps: editFormProps,
  //   modalProps: editModalProps,
  //   show: editShow,
  // } = useModalForm({
  //   resource: 'paper_templates',
  //   action: 'edit',
  //   metaData: paperTemplateMetaData,
  // })

  const { triggerExport, isLoading } = useExport<IPaperTemplate>()
  // const categoryQueryResult = useMany<ITestTrack>({
  //     resource: "categories",
  //     ids: [1, 2],
  // });

  const findPaperTemplateCounts = async () => {
    try {
      let userId = user?.id
      let isAdmin = userRole === 'admin'
      let userrole = userRole
      const resource = 'paper template'
      const responsePaperTemplateCount: any = await getCount({ userId, isAdmin, resource, userrole })
      let completedCount = responsePaperTemplateCount?.completedCount?.aggregate?.count
      let inProgressCount = responsePaperTemplateCount?.notCompletedCount?.aggregate?.count
      let totalPaperTemplate = completedCount + inProgressCount
      setPaperTemplateCounts({ completed: completedCount, inprogress: inProgressCount, totalPaperTemplate })
    } catch (err) {
      console.log(err, 'error')
    }
  }

  const { mutate } = useUpdate<IPaperTemplate>()
  // const confirm = async(e: React.MouseEvent<HTMLElement>, id: string) => {
  //   mutate({
  //     resource: 'paper_templates',
  //     id: id,
  //     values: { active: false },
  //   })
  // }

  const confirm = async (e: React.MouseEvent<HTMLElement>, id: string) => {
    mutate(
      {
        resource: 'paper_templates',
        id: id,
        values: { active: false },
      },
      {
        onSuccess: () => {
          findPaperTemplateCounts()
        },
      }
    )
  }

  const cancel = (e: React.MouseEvent<HTMLElement>) => {
    console.log(e)
  }
  // const onChange = (page: number, pageSize?: any): void => {
  //   setPageSize(pageSize)
  //   setCurrent(page)
  // }
  // const searchByName = (value: any) => {
  //   setCurrent(1)
  //   // setHasPagination(false)
  //   setPaperTemplateFilters(
  //     [
  //       {
  //         field: 'name',
  //         operator: 'contains',
  //         value: `%${value}%`,
  //       },
  //     ],
  //     'merge'
  //   )
  // }

  useEffect(() => {
    if (userRole !== undefined) {
      if (userRole === 'productmanager') {
        // setPaperTemplateFilters([
        //   {
        //     field: 'created_by',
        //     operator: 'eq',
        //     value: user?.id,
        //   },
        // ])
      } else if (['papersetter', 'paperapprover'].includes(userRole)) {
        setPaperTemplateFilters([], 'replace')
      }
      findPaperTemplateCounts()
    }
  }, [userRole])
  return (
    <>
      <List
        pageHeaderProps={{
          extra: [
            //  <ExportButton onClick={triggerExport} loading={isLoading} />,
            <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
            <CreateButton
              style={{ display: createPermission !== undefined && createPermission?.granted ? 'block' : 'none' }}
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => createShow()}
            />,
            <Button
              style={{ display: createPermission !== undefined && createPermission?.granted ? 'inline-flex' : 'none' }}
              icon={<MergeCellsOutlined />}
              onClick={() => setCombineOpen(true)}
            >
              Combine
            </Button>,
          ],
        }}
      >
        <Divider />
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={8} xl={6}>
            <div
              style={{
                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                padding: '1rem',
                height: '4rem',
                borderRadius: '10px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <h4>
                Total Paper Templates :{' '}
                <span style={{ fontSize: '16px', marginLeft: '5px', fontWeight: 'bold' }}>{paperTemplateCounts?.totalPaperTemplate}</span>
              </h4>
            </div>
          </Col>
          <Col xs={24} sm={12} md={12} lg={8} xl={6}>
            <div
              style={{
                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                padding: '1rem',
                height: '4rem',
                borderRadius: '10px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <h4>
                Completed Paper Templates :{' '}
                <span style={{ fontSize: '16px', marginLeft: '5px', fontWeight: 'bold' }}>{paperTemplateCounts?.completed}</span>
              </h4>
            </div>
          </Col>
          <Col xs={24} sm={12} md={12} lg={8} xl={6}>
            <div
              style={{
                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                padding: '1rem',
                height: '4rem',
                borderRadius: '10px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <h4>
                In Progress Paper Templates :{' '}
                <span style={{ fontSize: '16px', marginLeft: '5px', fontWeight: 'bold' }}>{paperTemplateCounts?.inprogress}</span>
              </h4>
            </div>
          </Col>
        </Row>
        <Divider />{' '}
        {/* <Input.Search
        placeholder="Search By Name"
        onChange={e => {
          if (e.type === 'click') {
            setHasPagination(true)
          }
        }}
        allowClear
        style={{ width: '100%' }}
        onSearch={(value: any) => searchByName(value)}
      /> */}
        <Form {...searchFormProps}>
          <Space>
            <Form.Item name="name">
              <Input placeholder="Search by Name" />
            </Form.Item>
            <Button type="primary" icon={<Icons.SearchOutlined />} onClick={searchFormProps.form?.submit}>
              Search
            </Button>
            <Button
              onClick={() => {
                searchFormProps?.form?.setFieldsValue({ name: '' })
                searchFormProps.form?.submit()
              }}
            >
              Clear
            </Button>
          </Space>
        </Form>
        <Divider />
        {readPermission !== undefined && readPermission.granted ? (
          <Table
            {...tableProps}
            // dataSource={tableQueryResult?.data?.data}
            rowKey="id"
            size="small"
            // pagination={{
            //     current,
            //     total: tableQueryResult?.data?.total,
            //     onChange,
            //   }}
          >
            <Table.Column
              dataIndex="name"
              title="Name"
              render={(_, record: any) => (
                <>
                  <ShowButton
                    size="small"
                    type="link"
                    icon={null}
                    recordItemId={record.id}
                    onClick={() => {
                      show('paper_templates', record.id)
                    }}
                  >
                    <Typography.Text
                      style={{
                        // width: 200,
                        textAlign: 'left',
                        color: '#6659FF',
                        cursor: 'pointer',
                      }}
                      ellipsis={{ tooltip: record?.name }}
                    >
                      {record?.name}
                    </Typography.Text>
                  </ShowButton>
                </>
              )}
            />
            <Table.Column dataIndex="description" title="Description" />
            <Table.Column<IPaperTemplate>
              dataIndex="is_completed"
              title="Status"
              render={(_, record: any) => (
                <Tag color={record?.is_completed ? 'green' : 'blue'}>{record?.is_completed ? 'Completed' : 'In Progress'}</Tag>
              )}
            />
            <Table.Column<IPaperTemplate> dataIndex="product" title="Product" render={(_, record) => record?.product?.name} />
            <Table.Column<IPaperTemplate> dataIndex="test_track" title="Test Track" render={(_, record) => record?.test_tracks?.name} />
            <Table.Column
              dataIndex="created_at"
              title="Created At"
              render={value => <DateField value={value} format="LLL" />}
              defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
              sorter
            />
            <Table.Column<IPaperTemplate>
              title="Actions"
              className={editPermission !== undefined && editPermission?.granted ? 'show' : 'hide'}
              dataIndex="actions"
              render={(_, record) => (
                <Space>
                  {editPermission !== undefined && editPermission?.granted ? (
                    <EditButton
                      size="small"
                      type="link"
                      hideText
                      onClick={() => {
                        edit('paper_templates', record.id)
                      }}
                      hidden={hasLinkedRecords(record) && !isEditGuardException(record)}
                    />
                  ) : null}
                  {createPermission !== undefined && createPermission?.granted ? (
                    <CloneButton
                      key="paper_template_clone"
                      size="small"
                      type="link"
                      hideText
                      title="Clone"
                      resourceNameOrRouteName="paper_templates"
                      icon={<Icons.CopyOutlined />}
                      recordItemId={record.id}
                      onClick={() => {
                        // cloneShow(record.id)
                        clone('paper_templates', record.id)
                      }}
                    />
                  ) : null}
                  {deletePermission !== undefined && deletePermission?.granted ? (
                    <Popconfirm
                      title="Are you sure to delete this task?"
                      onConfirm={(e: any) => confirm(e, record.id)}
                      onCancel={(e: any) => cancel(e)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button danger size="small" type="link" hidden={hasLinkedRecords(record)}>
                        <Icons.DeleteOutlined />
                      </Button>
                    </Popconfirm>
                  ) : null}
                  {/* <DeleteButton size="small" type="link" hideText recordItemId={record.id} /> */}
                </Space>
              )}
            />
          </Table>
        ) : null}
        <CreatePaperTemplate modalProps={modalProps} formProps={formProps} close={createClose} />
        <CombinePaperTemplatesModal
          open={combineOpen}
          onClose={() => setCombineOpen(false)}
          onSuccess={async () => {
            await tableQueryResult?.refetch()
            await findPaperTemplateCounts()
          }}
        />
        {/* <ClonePaperTemplate modalProps={cloneModalProps} formProps={cloneFormProps} record={record} /> */}
      </List>
    </>
  )
}
